import { createSlice } from '@reduxjs/toolkit'
import { IPhasesElement, PhaseState } from "./types";
import { applyExtraReducer } from "../../weather";
import { DashboardQueryParams } from "@pages/dashboard/phases";
import { createThunk, DashboardReqBodyWithDate } from "../crops/selector";
import { dashboardURL } from "@utils/utils";

const initialState: PhaseState = {
    data: [],
    isApiLoading: true,
    apiError: undefined
}

const fetchPhases = createThunk<IPhasesElement[], DashboardQueryParams, DashboardReqBodyWithDate>()(
    { url: dashboardURL('phasesByDate'), method: "POST" },
    (payload, url) => ({
        url,
        data: {
            cropRotationIds: payload.cropRotationIds || [],
            date: payload.date
        }
    })
)

const phasesDashboardSlice = createSlice({
    name: 'phasesDashboardSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        applyExtraReducer(builder, fetchPhases)
    },
})

export const actions = { ...phasesDashboardSlice.actions, fetchPhases }
export default phasesDashboardSlice.reducer